import User from "@mapmycustomers/shared/types/User";

import { UserColorClassNameGetter } from "@app/store/userColor/selectors";
import Cluster from "@app/util/clustering/types/Cluster";

import getSingleUserLocationStyles from "./getSingleUserLocationStyles";
import getUserLocationClusterStyles from "./getUserLocationClusterStyles";

interface StyleArguments {
  getUserColorClassName: UserColorClassNameGetter;
  selectedUser?: User;
  userIdToBase64Avatar: Map<User["id"], string>;
}

const userLocationStyleGetterFactory = ({
  getUserColorClassName,
  selectedUser,
  userIdToBase64Avatar,
}: StyleArguments): ((cluster: Cluster<User>) => google.maps.Data.StyleOptions) => {
  return (cluster: Cluster<User>) =>
    cluster.count === 1
      ? getSingleUserLocationStyles(
          cluster.items[0],
          selectedUser,
          getUserColorClassName,
          userIdToBase64Avatar
        )
      : getUserLocationClusterStyles(cluster, getUserColorClassName, userIdToBase64Avatar);
};

export default userLocationStyleGetterFactory;
